/**
 * CatalogView version selector.
 *
 * Default: v2 (new left-sidebar design). To roll back site-wide, change
 * DEFAULT_VERSION to 'v1'. To override per-session, append `?catalogView=v1`
 * to any URL or run `localStorage.setItem('catalogView','v1')` in devtools.
 * Full revert: delete CatalogView.v2.js and restore this file from
 * CatalogView.v1.js.
 */
import { CatalogView as CatalogViewV1 } from './CatalogView.v1';
import { CatalogView as CatalogViewV2 } from './CatalogView.v2';

const DEFAULT_VERSION = 'v2';

function resolveVersion() {
  if (typeof window === 'undefined') return DEFAULT_VERSION;
  try {
    const params = new URLSearchParams(window.location.search);
    const urlOverride = params.get('catalogView');
    if (urlOverride === 'v1' || urlOverride === 'v2') return urlOverride;
    const stored = window.localStorage.getItem('catalogView');
    if (stored === 'v1' || stored === 'v2') return stored;
  } catch {
    /* noop — fall through to default */
  }
  return DEFAULT_VERSION;
}

export function CatalogView(props) {
  return resolveVersion() === 'v1' ? <CatalogViewV1 {...props} /> : <CatalogViewV2 {...props} />;
}

export default CatalogView;
